import React from "react";

export const getLeadStatusClass = (status) => {
  const statusClassMap = {
    "E-sign completed": "status-esign-completed",
    Elected: "status-elected",
    Declined: "status-declined",
    "Enrollment Question": "status-enrollment-question",
    "Paycheck Illustration viewed": "status-paycheck-viewed",
    "Logged in and reviewing": "status-logged-reviewing",
    "Not logged in": "status-not-logged-in",
  };

  return statusClassMap[status] || "status-default";
};

export const LEAD_DETAILS_COLUMNS = [
  {
    title: "Lead Name",
    dataIndex: "name",
    key: "name",
    render: (text) => <span className="text-capitalize">{text}</span>,
  },
  {
    title: "Lead Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Lead Phone number",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Lead Status",
    dataIndex: "memberActionStatus",
    key: "memberActionStatus",
    render: (status) => (
      <span className={`lead-status-badge ${getLeadStatusClass(status)}`}>
        {status}
      </span>
    ),
  },
];
